// @ts-check
import { createApp } from "vue";
// @ts-ignore
import App from "./app.vue";
// @ts-ignore
import router from './router.vue';
import { store } from './store';
// @ts-ignore
import Toaster from '@meforma/vue-toaster';

const app = createApp(App);

app.use(store).use(router).use(Toaster).mount("#app");
